import React, { useEffect, useMemo, useState } from "react";
import ReportLayout from "../../../layouts/ReportMain";
import useGetCompanyInfo from "../../../hooks/useGetCompanyInfo";
import { useFormik } from "formik";
import { handleKeyDown } from "../../../utils/OtherFunctions";
import FormikSelectTwo from "../../../utils/Select";
import useFetchStandard from "../../../hooks/usFetchStandard";
import NuDateFormat from "../../../utils/NuDate";
import axiosInstance from "../../../services/axiosComman";
import { ReportModuleList } from "../../../assets/data/CountryMini";
import { NuDate } from "../../../utils/Inputs";
import { NormalButton, SubmitButton } from "../../../utils/Button";
import { useParams } from "react-router-dom";
import ViewReport from "./ViewReport";
import { renderTableHeader } from "./HeaderFunction";
import useGetStandardDetail from "../../../hooks/useGetStandardDetail";

function GenarateReport() {
  const { company } = useGetCompanyInfo();
  const { stdId } = useParams();
  const { standardList } = useFetchStandard();
  const [allOldData, setAllOldData] = useState([]);
  const [listOfOld, setListOfOld] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showReport, setShowReport] = useState(false);
  const [isDataLoading,setIsDataLoading] = useState(false)
  const [data, setData] = useState([]);
  const [status, setStatus] = useState({});
  const [review, setReview] = useState("");
  const [createNew, setCreateNew] = useState({
    report_information: "",
    format: "",
    standard_id: stdId || "",
    module_id: "",
    status_name: "",
    from_date: "",
    to_date: "",
    type: 0,
    report_year: "",
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    
    onSubmit: (value, { resetForm }) => {
      setShowReport(false)
      setIsDataLoading(true)
      setData([])
      setStatus([])
      let FinalData = { ...value };
      if (FinalData.from_date == startDate) {
        FinalData.from_date = "";
      }

      if (FinalData.to_date == endDate) {
        FinalData.to_date = "";
      }
      axiosInstance
        .post(`/report/`, FinalData)
        .then((res) => {
          let dateValue = res.data.data || [];
          if (dateValue.length > 0) {
            let fun = dateValue[0].final_status || null;
            if (fun == "review_and_approved") {
              setReview(true);
            } else {
              setReview("");
            }
          }
          res?.data?.data && setData(res?.data?.data);
          res.data?.status && setStatus(res.data?.status||[]);
        })
        .catch((err) => {
          console.log(err);
        });
      setShowReport(true);
    },
  });

  useMemo(() => {
    if (startDate) {
      formik.values.from_date = startDate;
    }
  }, [startDate]);

  useMemo(() => {
    if (endDate) {
      formik.values.to_date = endDate;
    }
  }, [endDate]);

  useMemo(() => {
    // console.log("woking",formik.values.report_year);
    if (formik.values.report_year) {
      let [data] = allOldData.filter(
        (item) => item.id == formik.values.report_year
      );
      console.log("report year",data);
      
      formik.values.type = data?.reset_count;
      formik.values.from_date = data.start_date;
      setStartDate(data.start_date);
      formik.values.to_date = data?.end_date;
      setEndDate(data?.end_date);
      // console.log(formik.values);
    }
  }, [formik.values.report_year]);

  function getAllOldData(value) {
    axiosInstance
      .get(`/Standards/getAllResetDate/${value}`)
      .then((res) => {
        let tempdata = res?.data?.data?.current_data || {};
        let tempObj = "";
        if (tempdata) {
          tempObj = {
            end_date: tempdata?.end_date || "",
            id: tempdata?.name || "",
            reset_date: "",
            standard_id: tempdata?.id || "",
            start_date: tempdata?.start_date || "",
            reset_count: 0,
          };
        }
        let finalArr = [];
        let tempResetData = res?.data?.data?.reset_data || [];

        tempResetData.push(tempObj);

        let finalListOfData = tempResetData;
        // && tempResetData.map(i=>({...i,type: i?.reset_date? 2:1}))

        res?.data?.data && setAllOldData(finalListOfData);
        res?.data?.data &&
          tempResetData.forEach((item) => {
            // if (item?.isActive && item?.keyActivated) {
            let temp = {
              value: item?.id,
              label: `${NuDateFormat({
                value: item?.start_date,
                format: "MMM-YYYY",
              })} to  ${NuDateFormat({
                value: item?.end_date,
                format: "MMM-YYYY",
              })}`,
            };
            finalArr.push(temp);
            // }
          });
        setListOfOld(finalArr.reverse());
      })
      .catch((err) => {
        console.log(err.response?.data);
      });
  }

  const {standardDetailName} = useGetStandardDetail({id:formik.values.standard_id})

  useEffect(() => {
    if (formik.values.standard_id) getAllOldData(formik.values.standard_id);
  }, [formik.values.standard_id]);

  useEffect(()=>{
    if(showReport==true){
      setData([])
      setShowReport(false)
    }
  },[formik.values.module_id])

  function ModuleName(x) {
    let Arr = [
      { value: 6, label: "Audit Schedule" },
      { value: 10, label: "Task Management" },
      { value: 1, label: "Implementation Checklist" },
      { value: 2, label: "Internal Audit Checklist" },
      { value: 3, label: "Maintenance" },
      { value: 4, label: "Master List of Documents" },
      { value: 18, label: "CISO / MRM Meeting " },
      { value: 12, label: "Security Incident" },
      { value: 16, label: "Training Calendar" },
      { value: 11, label: "Vendor Management" },
    ];
    let value = Arr.find((item) => item.value == x);
    return value?.label || "";
  }

  return (
    <ReportLayout>
      <div className=" w-full h-full relative overflow-y-auto">
        <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
          <div className="relative grid grid-cols-4">
            <FormikSelectTwo
              formik={formik}
              name="standard_id"
              label="Standard"
              width="w-full"
              placeholder="Select Standard"
              Options={standardList}
              zindex={12}
            />
            <FormikSelectTwo
              formik={formik}
              name="report_year"
              label="Year of Report"
              width="w-full"
              placeholder="Select Year of Report"
              Options={listOfOld}
              zindex={12}
            />
            <FormikSelectTwo
              formik={formik}
              name="module_id"
              label="Activity"
              width="w-full"
              placeholder="Select Activity"
              Options={ReportModuleList}
              zindex={12}
            />
            <FormikSelectTwo
              formik={formik}
              name="status_name"
              label="Status"
              width="w-full"
              placeholder="Select Status"
              Options={[
                { value: "", label: "All" },
                { value: "completed", label: "Completed" },
                { value: "in progress", label: "In Progress" },
                { value: "yet to start", label: "Yet to Start" },
              ]}
              zindex={12}
            />
            <FormikSelectTwo
              formik={formik}
              name="format"
              label="Format"
              width="w-full"
              placeholder="Select Format"
              Options={[
                { value: "pdf", label: "PDF" },
                { value: "xlsx", label: "XLSX" },
              ]}
              zindex={12}
            />
            <NuDate
              formik={formik}
              name="from_date"
              label="From"
              width="w-full"
              placeholder="Set From"
            />
            <NuDate
              formik={formik}
              name="to_date"
              label="To"
              width="w-full"
              placeholder="Set To"
            />
            <FormikSelectTwo
              formik={formik}
              name="report_information"
              label="Report Information"
              width="w-full"
              placeholder="Select Report Information"
              Options={[
                { value: "Summary", label: "Summary" },
                { value: "Detailed", label: "Detailed" },
              ]}
              zindex={12}
            />
          </div>
          <div className=" col-span-3 w-full flex justify-between items-center px-6 z-[999]">
            <SubmitButton label="Genarate" />
          </div>
        </form>
        <ViewReport
          header={
            (showReport == true &&
              renderTableHeader(
                formik.values.module_id,
                formik.values.report_information
              )) ||
            []
          }
          isDataLoading={isDataLoading}
          setIsDataLoading={setIsDataLoading}
          showReport={showReport}
          data={data}
          format={formik.values.format}
          Name={ModuleName(formik.values.module_id)}
          standardId={formik.values.standard_id}
          module={formik.values.module_id}
          view={formik.values.report_information}
          standardDetailName={standardDetailName}
          standardEndDate={formik.values.to_date}
          standardStartDate={formik.values.from_date}
          downloadFileName={`${standardDetailName}-${ModuleName(formik.values.module_id)} ${formik.values.report_information}.pdf`}
          status={status||{}}
          review={review}
        />
      </div>
    </ReportLayout>
  );
}

export default GenarateReport;
